
import React from 'react';



type Props = {
  className?: string;
}
export const ServiceCertCheckVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'white' d = 'M16.2222 3.77778V16.2222H3.77778V3.77778H16.2222ZM16.2222 2H3.77778C2.8 2 2 2.8 2 3.77778V16.2222C2 17.2 2.8 18 3.77778 18H16.2222C17.2 18 18 17.2 18 16.2222V3.77778C18 2.8 17.2 2 16.2222 2Z' />
      <path fill = 'white' d = 'M11.6 14H6V12.4H11.6V14ZM14 10.8H6V9.2H14V10.8ZM14 7.6H6V6H14V7.6Z' />
    </svg>
  );
};
